export default __webpack_public_path__ + "static/media/ic_flag_active.101decae.svg";